// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.custom-modal-content {
  background-color: #fff;
  border-radius: 5px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  border: 10px solid #00468c;
}

.modal-title {
  margin-top: 0;
  font-size: 1.5rem;
  opacity: 1!important;
  z-index: 99999!important;
  margin-left: 10%;
}

.modal-body {
  align-items: center;
  text-align: center;
}

.modal-buttons {
  display: flex;
  justify-content: center;
  padding: 2%;
}

.modal-buttons button {
  margin-left: 10px;
  padding: 8px 16px;
  border: none;
  border-radius: 3px;
  background-color: #7ac142;
  color: #fff;
  cursor: pointer;
}

.modal-buttons button:hover {
  background-color: #65a037;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".custom-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.custom-modal-content {\n  background-color: #fff;\n  border-radius: 5px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  border: 10px solid #00468c;\n}\n\n.modal-title {\n  margin-top: 0;\n  font-size: 1.5rem;\n  opacity: 1!important;\n  z-index: 99999!important;\n  margin-left: 10%;\n}\n\n.modal-body {\n  align-items: center;\n  text-align: center;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: center;\n  padding: 2%;\n}\n\n.modal-buttons button {\n  margin-left: 10px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 3px;\n  background-color: #7ac142;\n  color: #fff;\n  cursor: pointer;\n}\n\n.modal-buttons button:hover {\n  background-color: #65a037;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
